/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxOpenDocsIcon16Light = forwardRef('ArchiveBoxOpenDocsIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.5 0a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z" }),
        React.createElement("path", { d: "M6.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3.5A1.5 1.5 0 0 1 4.5 2h7A1.5 1.5 0 0 1 13 3.5V5h.5a.5.5 0 0 1 .5.5V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.5a.5.5 0 0 1 .5-.5H3V3.5Zm9 0V5H4V3.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5ZM3 12V6h10v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z" })));
});
